module.exports = __webpack_public_path__ + "static/media/horseback.34325548.jpg";